import React from "react";
import InputField from "./InputField";
import SubmitButton from "./SubmitButton";
import UserStore from "../../stores/UserStore";
import { Link } from "react-router-dom";
import { DropdownList, Multiselect } from "react-widgets";
import Can from "../authentication/Can";
import { alertService } from "../common/alert.service";
import { emailValidate, phoneValidate } from "../common/inputValidationHelpers";
import { Box, Grid } from "@material-ui/core";
import TextBox from "./TextBox";
import Table from "./ReactTable";
import PopUp from "../reusableComponents/PopUp";
import TableControlled from "../reusableComponents/TableControlled";

class OrderDisplay extends React.Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    this.state = {
      largeScreen: true,
      user: {},
      close: props.close,
      buttonDisabled: false,
      positionsList: [],
      departmentsList: [],
      employeesList: [],
      addressList: [],
      locationsList: [],
      roles: [],
      products: [],
      customers: [],
      unitActionRouteNames: [],
      CurrencyList: [],
      ContractsList: [],

      selectedOrderId: props.order.id,

      selectedOrderBillingAddressID: props.order.billingAddress.id,
      selectedOrderBillingAddress: props.order.billingAddress.name,
      selectedOrderBillingAddressIDOriginal: props.order.billingAddress.id,

      selectedOrderShippingAddressID: props.order.shippingAddress.id,
      selectedOrderShippingAddress: props.order.shippingAddress.name,
      selectedOrderShippingAddressIDOriginal: props.order.shippingAddress.id,
      
      selectedOrderPO: props.order.purchaseOrder,
      selectedOrderCurrencyType: props.order.currency.name,
      selectedOrderPrice: props.order.totalPrice,
      selectedOrderNotes: props.order.notes,
      selectedOrderStatus: props.order.status.name,
      selectedOrderCustomer: props.order.customer.name,
      selectedOrderContract: props.order.contract.name,
      selectedOrderSalesRep: props.order.salesRep.name,
      selectedOrderOrderDate: props.order.orderDate,
      selectedOrderSKUs: props.order.skus ? props.order.skus : [],
      
      selectedOrderPOOriginal: props.order.purchaseOrder,
      selectedOrderCurrencyTypeOriginal: props.order.currency.name,
      selectedOrderPriceOriginal: props.order.totalPrice,
      selectedOrderNotesOriginal: props.order.notes,
      selectedOrderStatusOriginal: props.order.status.name,
      selectedOrderCustomerOriginal: props.order.customer.name,
      selectedOrderContractOriginal: props.order.contract.name,

      allBillingAddresses: [],
      allShippingAddresses: [],
      allRoutingStages: [],
      allJobTypes:[],
      allWarehouses: [],
      
      selectedCOWorkOrderID: -1,
      selectedCOWorkOrderWarehouse: "",
      selectedCOWorkOrderWorkOrderName: "",
      selectedCOWorkOrderSerialNumber: "",
      selectedCOWorkOrderPrice:"",
      selectedCOWorkOrderExpectedCompletionDate: "",
      selectedCOWorkOrderJobType: "",
      selectedCOWorkOrderRoute: "",
      selectedCOWorkOrderTargetProduct: "",
      selectedCOWorkOrderShippingDate: "",
      selectedCOWorkOrderCurrentStage: "",
      selectedCOWorkOrderLastTouchedBy: "",
      selectedCOWorkOrderPriority: "",
      selectedCOWorkOrderPastUnitActions: [],
      
      selectedCOWorkOrderSerialNumberOriginal: "",
      selectedCOWorkOrderPriceOriginal:"",
      selectedCOWorkOrderJobTypeOriginal: "",

      MTIMECount: -1,

      //state variables for the selected SN SKU history table
      selectedOrderSNHistoryColumns: [
        { Header: "PO#", accessor: "pO" },
        { Header: "WO#", accessor: "wON" },
        { Header: "SKU", accessor: "sku" },
        { Header: "Rentrack Live Customer Order ID", accessor: "rentrackLiveCOID" },
        { Header: "Ship Date", accessor: "shippingDate" },
      ],

      selectedOrderSNHistoryRows: [],
      selectedOrderSNHistoryPageCount: 0,
      selectedOrderSNHistoryJobTypeFilter: "",
      loadingSelectedOrderSNHistoryRows: false,

      //state variable for work orders/order tickets table
      workOrderTableColumns: [
        { Header: "WO#", accessor: "workOrderName" },
        { Header: "Serial Number", accessor: "sN" },
        { Header: "SKU", accessor: "targetProduct.name" },
        { Header: "Ship Date", accessor: "shippingDate" },
      ],
      loadingCOWorkOrdersTable: false,
      selectedCOWorkOrders: [],
      selectedCOWorkOrdersPageCount: 0,
      selectedCOWorkOrdersPageSize: 10,
      viewingWorkOrder: false,

      //state variables for selected work order/order ticket
    };
  }

  async componentDidMount() {
    console.log(this.props)
    this._isMounted = true;
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));
    await this.getWorkOrders(0,10,[this.state.selectedOrderId]);
    //await this.getSNHistoricalSKUs(0,10,[this.state.selectedOrderSerialNumber]);
    await this.getBillingAddressesForCustomer();
    await this.getShippingAddressesForCustomer();
    await this.getProducts(0, 50, ["", ""]);
    await this.getCustomerOrderStatuses();
    await this.getCurrencies();
    await this.getJobs();
    await this.getUnitActionRouteNames();
    await this.getUnitActionRoutingStages();
    await this.getContracts(0, 50, [this.state.selectedOrderCustomer]);
    await this.getCustomers();
    await this.getAllWarehouses();
    await this.getUser();
  }
  
  async componentWillUnmount() {
    this._isMounted = false;
    window.removeEventListener("resize", this.updateDimensions.bind(this));
  }

  updateDimensions(){
    if (window.innerWidth > 960) {
      this.setInputValue('largeScreen',true)
    } else {
      this.setInputValue('largeScreen',false)
    }
  }

  setInputValue(property, val) {
    this._isMounted && this.setState(
      {
        [property]: val,
      },
      () => {}
    );
  }

  async getWorkOrders(pageIndex, pageSize, filters) {
    this.setInputValue("loadingCOWorkOrdersTable",true)
    try {
      let res = await fetch("/getWorkOrders", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          pageIndex: pageIndex,
          pageSize: pageSize,
          cOID: filters[0],
        }),
      });

      let result = await res.json();
      if (result && result.success) {
        this.setState({
          selectedCOWorkOrders: result.workOrders || [],
          selectedCOWorkOrdersPageCount: Math.ceil(result.total / pageSize),
          loadingCOWorkOrdersTable: false,
          selectedCOWorkOrdersPageSize: pageSize,
        });
      } else if (result && result.success === false) {
        console.log(result.msg);
      }
    } catch (e) {
      console.log(e);
    }
  }

  async getSNHistoricalSKUs(pageIndex, pageSize, filters) {
    this.setInputValue("loadingSelectedOrderSNHistoryRows",true)
    try {
      let res = await fetch("/getSNHistoricalSKUs", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          pageIndex: pageIndex,
          pageSize: pageSize,
          sN: filters[0],
          jobTypeFilter: filters[1],
        }),
      });

      let result = await res.json();
      if (result && result.success) {
        this.setState({
          selectedOrderSNHistoryRows: result.sNHistoryRows || [],
          selectedOrderSNHistoryPageCount: Math.ceil(result.total / pageSize),
          loadingSelectedOrderSNHistoryRows: false,
          selectedOrderSNHistoryPageSize: pageSize,
        });
      } else if (result && result.success === false) {
        console.log(result.msg);
      }
    } catch (e) {
      console.log(e);
    }
  }

  async getUser() {
    if (!UserStore.isLoggedIn) {
      return;
    }
    try {
      let res = await fetch("/getUser", {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      let result = await res.json();

      if (result && result.success) {
        this._isMounted && this.setState({
          user: result.user,
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  async getUnitActionRouteNames() {
    try {
      let res = await fetch("/getUnitActionRouteNames", {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      let result = await res.json();
      if (result && result.success) {
        this.setState({ unitActionRouteNames: result.routeNames });
      } else if (result && result.success === false) {
        alertService.error(result.msg);
      }
    } catch (e) {
      console.log(e);
    }
  }

  async getCurrencies() {
    try {
      let res = await fetch("/getCurrencies", {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      let result = await res.json();
      if (result && result.success) {
        this.setState({ CurrencyList: result.currencies });
      } else if (result && result.success === false) {
        alertService.error(result.msg);
      }
    } catch (e) {
      console.log(e);
    }
  }

  async getCustomers() {
    try {
      let res = await fetch("/getCustomers", {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      let result = await res.json();
      if (result && result.success) {
        this.setState({
          customers: result.customers,
        });
      } else if (result && result.success === false) {
        alertService.error(result.msg);
      }
    } catch (e) {
      console.log(e);
    }
  }
  
  async getCustomerOrderStatuses() {
    try {
      let res = await fetch("/getCustomerOrderStatuses", {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      let result = await res.json();
      if (result && result.success) {
        this.setState({
          COstatuses: result.statuses,
        });
      } else if (result && result.success === false) {
        alertService.error(result.msg);
      }
    } catch (e) {
      console.log(e);
    }
  }

  async getContracts(pageIndex, pageSize, filters) {
    try {
      let res = await fetch("/getContracts", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          pageIndex: pageIndex,
          pageSize: pageSize,
          customerFilter: filters[0],
        }),
      });

      let result = await res.json();
      if (result && result.success) {
        this.setState({
          ContractsList: result.contracts || [],
          contractsPageCount: Math.ceil(result.total / pageSize),
        }, () => {
          if (this.state.ContractsList.length === 0){
            window.alert("There are no active SLAs associated with the selected customer.");
          }
        });
      } else if (result && result.success === false) {
        console.log(result.msg);
      }
    } catch (e) {
      console.log(e);
    }
  }

  async saveWorkOrder() {
    let workOrderOkay = true
    
    if (this.state.ContractsList.filter(con => con.name === this.state.selectedOrderContract).map(con => con.productRevisions)[0].map(con => con.productRevision)
    .map(pr => pr.productRevisionDetails).map(prd => prd.sku).includes(this.state.selectedCOWorkOrderTargetProduct) === false) {
      workOrderOkay = false;
    }

    try {
      let res = await fetch("/saveWorkOrder", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          wOID: this.state.selectedCOWorkOrderID,
          sN: this.state.selectedCOWorkOrderSerialNumber,
          price: '$'+this.state.selectedCOWorkOrderPrice.replace("$",""),
          priceOriginal: '$'+this.state.selectedCOWorkOrderPriceOriginal.replace("$",""),
          sku: this.state.selectedCOWorkOrderTargetProduct,
          currentStage: this.state.selectedCOWorkOrderCurrentStage,
          expectedCompletionDate: this.state.selectedCOWorkOrderExpectedCompletionDate,
          priority: this.state.selectedCOWorkOrderPriority,
          jobType: this.state.selectedCOWorkOrderJobType,
          warehouseName: this.state.selectedCOWorkOrderWarehouse,
          routeName: this.state.selectedCOWorkOrderRoute,
          sNOriginal: this.state.selectedCOWorkOrderSerialNumberOriginal,
          jobTypeOriginal: this.state.selectedCOWorkOrderJobTypeOriginal,
          pOOriginal: this.state.selectedOrderPOOriginal,
        }),
      });

      let result = await res.json();
      if (result && result.success === true) {
        alertService.success("Saved item updates.")
        this.closeViewedOrder()
        this.getWorkOrders(0,10,[this.state.selectedOrderId])
      } else if (result && result.success === false) {
        console.log(result.msg);
      }
    } catch (e) {
      console.log(e);
    }
  }

  async saveCustomerOrder() {
    let orderOkay = true;

    if (this.state.selectedOrderContract !== this.state.selectedOrderContractOriginal) {
      this.state.selectedOrderSKUs.forEach(sku => {
        if (this.state.ContractsList.filter(con => con.name === this.state.selectedOrderContract).map(con => con.productRevisions)[0].map(con => con.productRevision)
        .map(pr => pr.productRevisionDetails).map(prd => prd.sku).includes(sku.name) === false){
          orderOkay = false;
        }
      });
    }

    if (orderOkay === false){
      window.alert("Not saved - There was at least one issue with the order updates")
    } else {
      try {
        let res = await fetch("/saveCustomerOrder", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            cOID: this.state.selectedOrderId,
            pO: this.state.selectedOrderPO,
            pOOriginal: this.state.selectedOrderPOOriginal,
            currencyTypeName: this.state.selectedOrderCurrencyType,
            billingAddressID: this.state.selectedOrderBillingAddressID,
            notes: this.state.selectedOrderNotes.replace("'","''"),
            status: this.state.selectedOrderStatus,
            customer: this.state.selectedOrderCustomer.replace("'","''"),
            customerOriginal: this.state.selectedOrderCustomerOriginal.replace("'","''"),
            shippingAddressID: this.state.selectedOrderShippingAddressID,
            shippingAddressIDOriginal: this.state.selectedOrderShippingAddressIDOriginal,
            shippingAddress: this.state.selectedOrderShippingAddress,
            MTIMECount: this.state.MTIMECount,
          }),
        });
  
        let result = await res.json();
        if (result && result.success === true) {
          this.state.close();
        } else if (result && result.success === false) {
          console.log(result.msg);
        }
      } catch (e) {
        console.log(e);
      }
    }
  }

  async closeViewedOrder() {
    this.setState({
      viewingWorkOrder: false,
      selectedCOWorkOrderID: -1,
      selectedCOWorkOrderWarehouse: "",
      selectedCOWorkOrderWorkOrderName: "",
      selectedCOWorkOrderSerialNumber: "",
      selectedCOWorkOrderSerialNumberOriginal: "",
      selectedCOWorkOrderPrice: "",
      selectedCOWorkOrderPriceOriginal: "",
      selectedCOWorkOrderExpectedCompletionDate: "",
      selectedCOWorkOrderJobType: "",
      selectedCOWorkOrderJobTypeOriginal: "",
      selectedCOWorkOrderRoute: "",
      selectedCOWorkOrderTargetProduct: "",
      selectedCOWorkOrderShippingDate: "",
      selectedCOWorkOrderCurrentStage: "",
      selectedCOWorkOrderLastTouchedBy: "",
      selectedCOWorkOrderPriority: "",
      selectedCOWorkOrderPastUnitActions: [],
    }, () => this.state.close())
  }

  async openWorkOrder(index){
    this.setState({
      viewingWorkOrder: true,
      selectedCOWorkOrderID: this.state.selectedCOWorkOrders[index].id,
      selectedCOWorkOrderWarehouse: this.state.selectedCOWorkOrders[index].warehouse.name,
      selectedCOWorkOrderWorkOrderName: this.state.selectedCOWorkOrders[index].workOrderName?this.state.selectedCOWorkOrders[index].workOrderName:"",
      selectedCOWorkOrderSerialNumber: this.state.selectedCOWorkOrders[index].sN,
      selectedCOWorkOrderSerialNumberOriginal: this.state.selectedCOWorkOrders[index].sN,
      selectedCOWorkOrderPrice: this.state.selectedCOWorkOrders[index].price,
      selectedCOWorkOrderPriceOriginal: this.state.selectedCOWorkOrders[index].price,
      selectedCOWorkOrderExpectedCompletionDate: this.state.selectedCOWorkOrders[index].expectedCompletionDate?this.state.selectedCOWorkOrders[index].expectedCompletionDate:"",
      selectedCOWorkOrderJobType: this.state.selectedCOWorkOrders[index].jobType?this.state.selectedCOWorkOrders[index].jobType.name:"",
      selectedCOWorkOrderJobTypeOriginal: this.state.selectedCOWorkOrders[index].jobType?this.state.selectedCOWorkOrders[index].jobType.name:"",
      selectedCOWorkOrderRoute: this.state.selectedCOWorkOrders[index].route?this.state.selectedCOWorkOrders[index].route.name:"",
      selectedCOWorkOrderTargetProduct: this.state.selectedCOWorkOrders[index].targetProduct?this.state.selectedCOWorkOrders[index].targetProduct.name:"",
      selectedCOWorkOrderShippingDate: this.state.selectedCOWorkOrders[index].shippingDate,
      selectedCOWorkOrderCurrentStage: this.state.selectedCOWorkOrders[index].stage?this.state.selectedCOWorkOrders[index].stage.name:"",
      selectedCOWorkOrderLastTouchedBy: this.state.selectedCOWorkOrders[index].lastTouchedBy?this.state.selectedCOWorkOrders[index].lastTouchedBy.name:"",
      selectedCOWorkOrderPriority: this.state.selectedCOWorkOrders[index].priority?this.state.selectedCOWorkOrders[index].priority:"",
      selectedCOWorkOrderPastUnitActions: this.state.selectedCOWorkOrders[index].pastUnitActions ? this.state.selectedCOWorkOrders[index].pastUnitActions : [],
    })
  }
    
  async getUnitActionRoutingStages() {
    try {
      let res = await fetch("/getUnitActionRoutingStages", {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      let result = await res.json();
      if (result && result.success === true) {
        this.setState({ allRoutingStages: result.routingStages });
      } else if (result && result.success === false) {
        alertService.error(result.msg);
      }
    } catch (e) {
      console.log(e);
    }
  }

  async getJobs() {
    try {
      let res = await fetch("/getJobs", {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      let result = await res.json();
      if (result && result.success) {
        this._isMounted && this.setState({ allJobTypes: result.jobs });
      } else if (result && result.success === false) {
        console.log(result.msg);
      }
    } catch (e) {
      console.log(e);
    }
  }

  async getBillingAddressesForCustomer(){
    try {
      let res = await fetch("/getBillingAddressesForCustomer", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          customerName: this.state.selectedOrderCustomer.replace("'","''"),
        }),
      });

      let result = await res.json();
      if (result && result.success) {
        this.setState({
          allBillingAddresses: result.billingAddresses,
        });
      } else if (result && result.success === false) {
        console.log(result.msg);
      }
    } catch (e) {
      console.log(e);
    }
  }

  async getShippingAddressesForCustomer(){
    try {
      let res = await fetch("/getShippingAddressesForCustomer", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          customerName: this.state.selectedOrderCustomer.replace("'","''"),
        }),
      });

      let result = await res.json();
      if (result && result.success) {
        this.setState({
          allShippingAddresses: result.shippingAddresses,
        });
      } else if (result && result.success === false) {
        console.log(result.msg);
      }
    } catch (e) {
      console.log(e);
    }
  }
  
  async getProducts(pageIndex, pageSize, filters) {

    try {
      let res = await fetch("/getProducts", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          pageIndex: pageIndex,
          pageSize: pageSize,
          SKUFilter: filters[0],
          descriptionFilter: filters[1].replace("'","''"),
        }),
      });

      let result = await res.json();
      if (result && result.success) {
        this.setState({
          products: result.products || [],
        });
      } else if (result && result.success === false) {
        alertService.error(result.msg);
      }
    } catch (e) {
      console.log(e);
    }
    this.setState({ loadingTable: false });
  }

  async getMTIMECienaCount(sku)
  {
    try {
      let res = await fetch("/getMTIMECienaCount", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          sku: sku,
        }),
      });

      let result = await res.json();
      if (result && result.success === true) {
        this.setState({
          MTIMECount: result.total,
        })
      } else if (result && result.success === false) {
        console.log(result.msg);
      }
    } catch (e) {
      console.log(e);
    }
  }

  async getAllWarehouses() {
    try {
      let res = await fetch("/getAllWarehouses", {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      let result = await res.json();
      if (result && result.success) {
        this.setState({ allWarehouses: result.warehouses });
      } else if (result && result.success === false) {
        alertService.error(result.msg);
      }
    } catch (e) {
      console.log(e);
    }
  }

  async getSLAPrice(sku, contractName, jobType)
  {
    try {
      let res = await fetch("/getSLAPrice", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          sku: sku,
          contractName: contractName,
          jobType: jobType,
        }),
      });

      let result = await res.json();
      if (result && result.success === true) {
        this.setState({
          selectedCOWorkOrderPrice: result.price,
        })
      } else if (result && result.success === false) {
        console.log(result.msg);
      }
    } catch (e) {
      console.log(e);
    }
  }

  render() {
    return (
      <Box display="flex" flexDirection="column" justifyContent="space-around" padding={2}>
        <Can
          role={UserStore.permissions}
          perform="orders:edit"
          yes={() => (
            <Box>
              <Box p={2} display="flex" flexDirection="row" flexWrap="wrap">

                <Box p={2} justifyContent="space-around" display="flex" flexDirection="column">
                  <h3>Customer Order: </h3>{" "}
                  <div className="instructions"> (SLA:{" "}
                    {this.state.selectedOrderContract})
                  </div>
                </Box>
                <Box p={2} justifyContent="space-around" display="flex" flexDirection="column">
                  <TextBox
                    type="text"
                    label="PO Number"
                    placeholder="PO Number"
                    value={
                      this.state.selectedOrderPO
                        ? this.state.selectedOrderPO
                        : ""
                    }
                    onChange={(val) => {
                      let newVal = val.target.value;
                      this.setState({
                        selectedOrderPO: newVal,
                      })
                    }}
                    onKeyDown={(e) => {}}
                  />{" "}
                </Box>
                <Box p={2} justifyContent="space-around" display="flex" flexDirection="column" width={200}>
                  <div>Customer:</div>
                  <DropdownList
                    filter
                    className="medium"
                    data={this.state.customers.map(cust => cust.name)}
                    value={this.state.selectedOrderCustomer}
                    onChange={(val) => {
                      this.setState({
                        selectedOrderCustomer: val,
                      }, () => {
                        this.getContracts(0, 50, [this.state.selectedOrderCustomer]);
                        this.setInputValue("selectedOrderContract", "");
                        if (this.state.selectedOrderCustomer.toUpperCase().includes("CIENA")){
                          this.getMTIMECienaCount(this.state.selectedOrderTargetProduct)
                        }
                      })
                    }}
                  />
                </Box>
                <Box p={2} justifyContent="space-around" display="flex" flexDirection="column" width={200}>
                  <div>Contract:</div>
                  <DropdownList
                    filter
                    className="medium"
                    data={this.state.ContractsList.map(contract => contract.name)}
                    value={this.state.selectedOrderContract}
                    onChange={(val) => {
                      this.setState({
                        selectedOrderContract: val,
                      }, () => {
                        this.state.selectedOrderSKUs.forEach(sku => {
                          if (this.state.ContractsList.filter(con => con.name === this.state.selectedOrderContract).map(con => con.productRevisions)[0].map(con => con.productRevision).map(pr => pr.productRevisionDetails).map(prd => prd.sku).includes(sku.name) === false){
                            window.alert("The selected SLA does not contain a price for the SKU - " + sku.name)
                          }
                        });
                      })
                    }}
                  />
                </Box>
                <Box p={2} justifyContent="space-around" display="flex" flexDirection="column" width={200}>
                  <div>Status:</div>
                  <DropdownList
                    filter
                    className="medium"
                    data={this.state.COstatuses}
                    textField="name"
                    value={this.state.selectedOrderStatus}
                    onChange={(val) => {
                      this.setState({
                        selectedOrderStatus: val,
                      })
                    }}
                  />
                </Box>
                <Box p={2} justifyContent="space-around" display="flex" flexDirection="column">
                  Order Date: {this.state.selectedOrderOrderDate.split("T")[0]}
                </Box>
                <Box p={2} justifyContent="space-around" display="flex" flexDirection="column" width={200}>
                  <div>Currency:</div>
                  <DropdownList
                    data={this.state.CurrencyList.map(currency => currency.name)}
                    value={this.state.selectedOrderCurrencyType}
                    onChange={(val) => {
                      this.setState({
                        selectedOrderCurrencyType: val,
                      })
                    }}
                  />
                </Box>
                <Box p={2} justifyContent="space-around" display="flex" flexDirection="column">
                  <TextBox
                    disabled
                    type="number"
                    min="0.00"
                    step="0.01"
                    label="Total Price"
                    startAdornment="$"
                    endAdornment={this.state.selectedOrderCurrencyType || ""}
                    value={
                      this.state.selectedOrderPrice.includes("$")
                        ? parseFloat(this.state.selectedOrderPrice.substring(1).replace('$','')).toFixed(2).toString()
                        : parseFloat(this.state.selectedOrderPrice.replace('$','')).toFixed(2).toString()
                    }
                    onKeyDown={(e) => {}}
                    onChange={(val) => {
                      let newVal = val.target.value;
                    }}
                  />{" "}
                </Box>
                <Box p={2} justifyContent="space-around" display="flex" flexDirection="column" width={200}>
                  <span>Billing Address:</span>
                  <DropdownList
                    filter
                    data={this.state.allBillingAddresses.map(item => item.name)}
                    value={this.state.selectedOrderBillingAddress}
                    onChange={(val) => {
                      this.setInputValue("selectedOrderBillingAddress", val);
                      this.setInputValue("selectedOrderBillingAddressID", this.state.allBillingAddresses[this.state.allBillingAddresses.map(addr => addr.name).indexOf(val)].id)
                    }}
                  />
                </Box>
                <Box p={2} justifyContent="space-around" display="flex" flexDirection="column" width={200}>
                  <span>Shipping Address:</span>
                  <DropdownList
                    filter
                    data={this.state.allShippingAddresses.map(item => item.name)}
                    value={this.state.selectedOrderShippingAddress}
                    onChange={(val) => {
                      this.setInputValue("selectedOrderShippingAddress", val);
                      this.setInputValue("selectedOrderShippingAddressID", this.state.allShippingAddresses[this.state.allShippingAddresses.map(addr => addr.name).indexOf(val)].id)
                    }}
                  />
                </Box>
                <Box p={2} justifyContent="space-around" display="flex" flexDirection="column">
                  <Box p={2}>
                    <label className="notes_label">Notes:</label>
                  </Box>
                  <Box p={2}>
                    <textarea className="notes" value={this.state.selectedOrderNotes?this.state.selectedOrderNotes:""} onChange={(val) => {
                      let newVal = val.target.value;
                      this.setState({
                        selectedOrderNotes: newVal
                      });
                    }} />
                  </Box>
                </Box>

              </Box>
              
            </Box>
          )}
          no={() => {
            return (
              <Box>
              <Box p={2} display="flex" flexDirection="row" flexWrap="wrap">

                <Box p={2} justifyContent="space-around" display="flex" flexDirection="column">
                  <h3>Customer Order: </h3>{" "}
                  <div className="instructions"> (SLA:{" "}
                    {this.state.selectedOrderContract})
                  </div>
                </Box>
                <Box p={2} justifyContent="space-around" display="flex" flexDirection="column">
                  <TextBox
                    disabled
                    type="text"
                    label="PO Number"
                    placeholder="PO Number"
                    value={
                      this.state.selectedOrderPO
                        ? this.state.selectedOrderPO
                        : ""
                    }
                    onChange={(val) => {
                      console.log(val)
                    }}
                    onKeyDown={(e) => {}}
                  />{" "}
                </Box>
                <Box p={2} justifyContent="space-around" display="flex" flexDirection="column" width={200}>
                  <div>Customer:</div>
                  <DropdownList
                    disabled
                    filter
                    className="medium"
                    data={this.state.customers.map(cust => cust.name)}
                    value={this.state.selectedOrderCustomer}
                    onChange={(val) => {
                    }}
                  />
                </Box>
                <Box p={2} justifyContent="space-around" display="flex" flexDirection="column" width={200}>
                  <div>Contract:</div>
                  <DropdownList
                    disabled
                    filter
                    className="medium"
                    data={this.state.ContractsList.map(contract => contract.name)}
                    value={this.state.selectedOrderContract}
                    onChange={(val) => {
                    }}
                  />
                </Box>
                <Box p={2} justifyContent="space-around" display="flex" flexDirection="column" width={200}>
                  <div>Status:</div>
                  <DropdownList
                    disabled
                    filter
                    className="medium"
                    data={this.state.COstatuses}
                    textField="name"
                    value={this.state.selectedOrderStatus}
                    onChange={(val) => {
                    }}
                  />
                </Box>
                <Box p={2} justifyContent="space-around" display="flex" flexDirection="column">
                  Order Date: {this.state.selectedOrderOrderDate.split("T")[0]}
                </Box>
                <Box p={2} justifyContent="space-around" display="flex" flexDirection="column" width={200}>
                  <div>Currency:</div>
                  <DropdownList
                    disabled
                    data={this.state.CurrencyList}
                    value={this.state.selectedOrderCurrencyType}
                    textField="name"
                    onChange={(val) => {
                    }}
                  />
                </Box>
                <Box p={2} justifyContent="space-around" display="flex" flexDirection="column">
                  <TextBox
                    disabled
                    type="number"
                    min="0.00"
                    step="0.01"
                    label="Total Price"
                    startAdornment="$"
                    endAdornment={this.state.selectedOrderCurrencyType || ""}
                    value={
                      this.state.selectedOrderPrice.includes("$")
                        ? parseFloat(this.state.selectedOrderPrice.substring(1).replace('$','')).toFixed(2).toString()
                        : parseFloat(this.state.selectedOrderPrice.replace('$','')).toFixed(2).toString()
                    }
                    onKeyDown={(e) => {}}
                    onChange={(val) => {
                      let newVal = val.target.value;
                    }}
                  />{" "}
                </Box>
                <Box p={2} justifyContent="space-around" display="flex" flexDirection="column" width={200}>
                  <span>Billing Address:</span>
                  <DropdownList
                    disabled
                    filter
                    data={this.state.allBillingAddresses.map(item => item.name)}
                    value={this.state.selectedOrderBillingAddress}
                    onChange={(val) => {
                    }}
                  />
                </Box>
                <Box p={2} justifyContent="space-around" display="flex" flexDirection="column" width={200}>
                  <span>Shipping Address:</span>
                  <DropdownList
                    disabled
                    filter
                    data={this.state.allShippingAddresses.map(item => item.name)}
                    value={this.state.selectedOrderShippingAddress}
                    onChange={(val) => {
                    }}
                  />
                </Box>
                <Box p={2} justifyContent="space-around" display="flex" flexDirection="column">
                  <Box p={2}>
                    <label className="notes_label">Notes:</label>
                  </Box>
                  <Box p={2}>
                    <textarea disabled className="notes" value={this.state.selectedOrderNotes?this.state.selectedOrderNotes:""} onChange={(val) => {
                      let newVal = val.target.value;
                    }} />
                  </Box>
                </Box>

              </Box>
            </Box>
            );
          }}
        />

        
        <TableControlled
          columns={this.state.workOrderTableColumns}
          data={this.state.selectedCOWorkOrders}
          fetchData={(pageIndex, pageSize, filters) =>
            this.getWorkOrders(pageIndex, pageSize, filters)
          }
          pageSize={this.state.selectedCOWorkOrdersPageSize}
          pageCount={this.state.selectedCOWorkOrdersPageCount}
          filters={[]}
          loading={this.state.loadingCOWorkOrdersTable}
          getRowProps={(row) => {
            return({
              className: "clickable",
              onClick: () => {
                this.openWorkOrder(row.index)
              },
            })
          }}
        />

        <Can
          role={UserStore.permissions}
          perform="orders:edit"
          yes={() => (<>
            <Box p={2}>
              <SubmitButton text="Save" onClick={() => {
                this.saveCustomerOrder();
              }} />{" "}
            </Box>
          </>)}
          no={() => (<></>)}
        />

        <Box p={2}>
          <SubmitButton text="Close" onClick={() => this.state.close()} />{" "}
        </Box>

        <PopUp
          openStateVariable={this.state.viewingWorkOrder}
          onCloseFunction={() => {
            this.setState({ showAddAddressPopUp: false });
          }}
          largeScreen={this.state.largeScreen}
          dialogContent={
            <>
              <Box p={2} display="flex" flexDirection="column" flexWrap="wrap">
                <Box p={2} justifyContent="space-around" display="flex" flexDirection="column">
                  <h3>Work Order:</h3>
                  <span>(ID: {this.state.selectedCOWorkOrderID})</span>
                </Box>

                <Can
                  role={UserStore.permissions}
                  perform="orders:edit"
                  yes={() => (
                    <Box p={2} justifyContent="space-around" display="flex" flexDirection="row" flexWrap="wrap">
                      <Box p={2}>
                        <TextBox
                          label="Serial Number"
                          required
                          type="text"
                          value={this.state.selectedCOWorkOrderSerialNumber?this.state.selectedCOWorkOrderSerialNumber:""}
                          onChange={event => {
                            const { value } = event.target;
                            this.setState({
                              selectedCOWorkOrderSerialNumber: value
                            })
                          }}
                          onKeyDown={(e) => {}}
                        />
                      </Box>
                      <Box p={2}>
                        <TextBox
                          disabled
                          label="Price"
                          required
                          type="text"
                          value={this.state.selectedCOWorkOrderPrice?this.state.selectedCOWorkOrderPrice:""}
                          onChange={event => {
                            const { value } = event.target;
                          }}
                          onKeyDown={(e) => {}}
                        />
                      </Box>
                      <Box p={2} justifyContent="space-around" display="flex" flexDirection="column" width={200}>
                        SKU:
                        <DropdownList
                          filter
                          data={this.state.products.map(prod => prod.sku)}
                          value={this.state.selectedCOWorkOrderTargetProduct}
                          minLength={3}
                          onSearch={(searchTerm) =>
                            this.getProducts(0, 50, [
                              searchTerm,
                              "",
                            ])
                          }
                          onChange={(val) =>
                            this.setState({
                              selectedCOWorkOrderTargetProduct: val,
                            }, () => {
                              if (this.state.ContractsList.filter(con => con.name === this.state.selectedOrderContract).map(con => con.productRevisions)[0].map(con => con.productRevision)
                              .map(pr => pr.productRevisionDetails).map(prd => prd.sku).includes(this.state.selectedCOWorkOrderTargetProduct) === false) {
                                window.alert("The selected SKU has no pricing in the SLA - " + this.state.selectedOrderContract);
                              }
                            })
                          }
                        />
                      </Box>
                      <Box p={2} justifyContent="space-around" display="flex" flexDirection="column" width={200}>
                        <div>Warehouse:</div>
                        <DropdownList
                          filter
                          className="medium"
                          data={this.state.allWarehouses.map(warehouse => warehouse.name)}
                          value={this.state.selectedCOWorkOrderWarehouse}
                          onChange={(val) => {
                            this.setState({
                              selectedCOWorkOrderWarehouse: val,
                            })
                          }}
                        />
                      </Box>
                      <Box p={2} justifyContent="space-around" display="flex" flexDirection="column">
                        Ship Date:{" "}
                        {this.state.selectedCOWorkOrderShippingDate
                          ? this.state.selectedCOWorkOrderShippingDate
                          : "Not Shipped"}
                      </Box>
                      <Box p={2} width={200} justifyContent="space-around" display="flex" flexDirection="column">
                        <span>Current Stage*:</span>
                        <DropdownList
                          data={this.state.allRoutingStages.map(stage => stage.name)}
                          value={this.state.selectedCOWorkOrderCurrentStage}
                          onChange={event => {
                            const { value } = event.target;
                            this.setState({
                              selectedCOWorkOrderCurrentStage: value
                            }, () => {
                              if (this.state.selectedCOWorkOrderJobType.toUpperCase() === "STRIP & SURVEY"
                              && this.state.selectedCOWorkOrderCurrentStage.toUpperCase() === "WORK ORDER CLOSE-STOCK TRANSFER"
                              && this.state.selectedCOWorkOrderPastUnitActions.map(action => action.stage.name.toUpperCase()).includes("REPAIR")){
                                this.getSLAPrice(this.state.selectedCOWorkOrderTargetProduct, this.state.selectedOrderContract, this.state.selectedCOWorkOrderJobType)
                              }
                            })
                          }}
                        />
                      </Box>
                      <Box p={2} justifyContent="space-around" display="flex" flexDirection="column">
                        <TextBox
                          disabled
                          label="Last Touched By"
                          type="text"
                          value={this.state.selectedCOWorkOrderLastTouchedBy?this.state.selectedCOWorkOrderLastTouchedBy:""}
                          onChange={event => {}}
                          onKeyDown={(e) => {}}
                        />
                      </Box>
                      <Box p={2} justifyContent="space-around" display="flex" flexDirection="column">
                        <TextBox
                          disabled
                          label="Work Order Number"
                          required
                          type="text"
                          value={this.state.selectedCOWorkOrderWorkOrderName?this.state.selectedCOWorkOrderWorkOrderName:""}
                          onChange={event => {
                            const { value } = event.target;
                          }}
                          onKeyDown={(e) => {}}
                        />
                      </Box>
                      <Box p={2} justifyContent="space-around" display="flex" flexDirection="column">
                        <TextBox
                          label="Expected Completion Date"
                          required
                          type="date"
                          value={this.state.selectedCOWorkOrderExpectedCompletionDate?this.state.selectedCOWorkOrderExpectedCompletionDate.split("T")[0]:""}
                          onChange={event => {
                            const { value } = event.target;
                            this.setState({
                              selectedCOWorkOrderExpectedCompletionDate: value
                            })
                          }}
                          onKeyDown={(e) => {}}
                        />
                      </Box>
                      <Box p={2} justifyContent="space-around" display="flex" flexDirection="column">
                        <TextBox
                          label="Priority"
                          required
                          type="text"
                          value={this.state.selectedCOWorkOrderPriority?this.state.selectedCOWorkOrderPriority:""}
                          onChange={event => {
                            const { value } = event.target;
                            this.setState({
                              selectedCOWorkOrderPriority: value
                            })
                          }}
                          onKeyDown={(e) => {}}
                        />
                      </Box>
                      <Box p={2} width={200} justifyContent="space-around" display="flex" flexDirection="column">
                        <span>Job Type*:</span>
                        <DropdownList
                          data={this.state.allJobTypes.map(type => type.name)}
                          value={this.state.selectedCOWorkOrderJobType}
                          onChange={(val) => {;
                            this.setState({
                              selectedCOWorkOrderJobType: val,
                            }, () => {
                              if (this.state.selectedCOWorkOrderJobType !== this.state.selectedCOWorkOrderJobTypeOriginal) {
                                this.setInputValue("selectedCOWorkOrderRoute", this.state.allJobTypes[this.state.allJobTypes.map(type => type.name).indexOf(this.state.selectedCOWorkOrderJobType)].routeName)
                              }
                            })
                          }}
                        />
                      </Box>
                      <Box p={2} width={200} justifyContent="space-around" display="flex" flexDirection="column">
                        <span>Routing:</span>
                        <DropdownList
                          data={this.state.unitActionRouteNames.map(route => route.name)}
                          value={this.state.selectedCOWorkOrderRoute}
                          onChange={event => {
                            const { value } = event.target;
                            this.setState({
                              selectedCOWorkOrderRoute: value
                            })
                          }}
                        />
                      </Box>
                    </Box>
                  )}
                  no={() => (
                    <Box p={2} justifyContent="space-around" display="flex" flexDirection="row" flexWrap="wrap">
                      <Box p={2}>
                        <TextBox
                          disabled
                          label="Serial Number"
                          required
                          type="text"
                          value={this.state.selectedCOWorkOrderSerialNumber?this.state.selectedCOWorkOrderSerialNumber:""}
                          onChange={event => {
                            const { value } = event.target;
                          }}
                          onKeyDown={(e) => {}}
                        />
                      </Box>
                      <Box p={2}>
                        <TextBox
                          disabled
                          label="Price"
                          required
                          type="text"
                          value={this.state.selectedCOWorkOrderPrice?this.state.selectedCOWorkOrderPrice:""}
                          onChange={event => {
                            const { value } = event.target;
                          }}
                          onKeyDown={(e) => {}}
                        />
                      </Box>
                      <Box p={2} justifyContent="space-around" display="flex" flexDirection="column" width={200}>
                        SKU:
                        <DropdownList
                          disabled
                          filter
                          data={this.state.products.map(prod => prod.sku)}
                          value={this.state.selectedCOWorkOrderTargetProduct}
                          minLength={3}
                          onSearch={(searchTerm) =>
                            this.getProducts(0, 50, [
                              searchTerm,
                              "",
                            ])
                          }
                          onChange={(val) =>
                            {

                            }
                          }
                        />
                      </Box>
                      <Box p={2} justifyContent="space-around" display="flex" flexDirection="column" width={200}>
                        <div>Warehouse:</div>
                        <DropdownList
                          filter
                          disabled
                          className="medium"
                          data={this.state.allWarehouses.map(warehouse => warehouse.name)}
                          value={this.state.selectedCOWorkOrderWarehouse}
                          onChange={(val) => {
                          }}
                        />
                      </Box>
                      <Box p={2} justifyContent="space-around" display="flex" flexDirection="column">
                        Ship Date:{" "}
                        {this.state.selectedCOWorkOrderShippingDate
                          ? this.state.selectedCOWorkOrderShippingDate
                          : "Not Shipped"}
                      </Box>
                      <Box p={2} width={200} justifyContent="space-around" display="flex" flexDirection="column">
                        <span>Current Stage*:</span>
                        <DropdownList
                          disabled
                          data={this.state.allRoutingStages.map(stage => stage.name)}
                          value={this.state.selectedCOWorkOrderCurrentStage}
                          onChange={event => {
                            const { value } = event.target;
                          }}
                        />
                      </Box>
                      <Box p={2} justifyContent="space-around" display="flex" flexDirection="column">
                        <TextBox
                          label="Last Touched By"
                          type="text"
                          disabled={true}
                          value={this.state.selectedCOWorkOrderLastTouchedBy?this.state.selectedCOWorkOrderLastTouchedBy:""}
                          onChange={event => {}}
                          onKeyDown={(e) => {}}
                        />
                      </Box>
                      <Box p={2} justifyContent="space-around" display="flex" flexDirection="column">
                        <TextBox
                          disabled
                          label="Work Order Number"
                          required
                          type="text"
                          value={this.state.selectedCOWorkOrderWorkOrderName?this.state.selectedCOWorkOrderWorkOrderName:""}
                          onChange={event => {
                            const { value } = event.target;
                          }}
                          onKeyDown={(e) => {}}
                        />
                      </Box>
                      <Box p={2} justifyContent="space-around" display="flex" flexDirection="column">
                        <TextBox
                          disabled
                          label="Expected Completion Date"
                          required
                          type="date"
                          value={this.state.selectedCOWorkOrderExpectedCompletionDate?this.state.selectedCOWorkOrderExpectedCompletionDate.split("T")[0]:""}
                          onChange={event => {
                            const { value } = event.target;
                          }}
                          onKeyDown={(e) => {}}
                        />
                      </Box>
                      <Box p={2} justifyContent="space-around" display="flex" flexDirection="column">
                        <TextBox
                          disabled
                          label="Priority"
                          required
                          type="text"
                          value={this.state.selectedCOWorkOrderPriority?this.state.selectedCOWorkOrderPriority:""}
                          onChange={event => {
                            const { value } = event.target;
                          }}
                          onKeyDown={(e) => {}}
                        />
                      </Box>
                      <Box p={2} width={200} justifyContent="space-around" display="flex" flexDirection="column">
                        <span>Job Type*:</span>
                        <DropdownList
                          disabled
                          data={this.state.allJobTypes}
                          value={this.state.selectedCOWorkOrderJobType}
                          onChange={event => {
                            const { value } = event.target;
                          }}
                        />
                      </Box>
                      <Box p={2} width={200} justifyContent="space-around" display="flex" flexDirection="column">
                        <span>Routing:</span>
                        <DropdownList
                          disabled
                          data={this.state.unitActionRouteNames.map(route => route.name)}
                          value={this.state.selectedCOWorkOrderRoute}
                          onChange={event => {
                            const { value } = event.target;
                          }}
                        />
                      </Box>
                    </Box>
                  )}
                />
                
                <Box p={2}>
                  <h3>Selected SN SKU History:</h3>
                </Box>

                <Box p={2}>
                  <h6>Type Filter:</h6>
                </Box>

                <Box p={2} width={200}>
                  <DropdownList
                    data={this.state.allJobTypes.map(type => type.name)}
                    value={this.state.selectedOrderSNHistoryJobTypeFilter}
                    onChange={(val) => {
                      this.setState({
                        selectedOrderSNHistoryJobTypeFilter: val,
                      }, () => {
                        this.getSNHistoricalSKUs(0,10,[this.state.selectedOrderSerialNumber, this.state.selectedOrderSNHistoryJobTypeFilter])
                      })
                    }}
                  />
                </Box>

                <TableControlled
                  columns={this.state.selectedOrderSNHistoryColumns}
                  data={this.state.selectedOrderSNHistoryRows}
                  fetchData={(pageIndex, pageSize, filters) =>
                    this.getSNHistoricalSKUs(pageIndex, pageSize, filters)
                  }
                  pageSize={this.state.selectedOrderSNHistoryPageSize}
                  pageCount={this.state.selectedOrderSNHistoryPageCount}
                  filters={[
                    this.state.selectedOrderSerialNumber, this.state.selectedOrderSNHistoryJobTypeFilter
                  ]}
                  loading={this.state.loadingSelectedOrderSNHistoryRows}
                  getRowProps={(row) => {
                    if (row.original["jobType"]==="Warranty"){
                      return({
                        className: "green",
                        onClick: () => {},
                      })
                    } else {
                      return({
                        className: "clickable",
                        onClick: () => {},
                      })
                    }
                  }}
                />

                <Box display="flex" flexDirection="column" p={2}>
                  <SubmitButton
                    text="Save Item"
                    onClick={() => this.saveWorkOrder()}
                  />
                  <SubmitButton
                    text="Close"
                    disabled={false}
                    onClick={() => {
                      this.closeViewedOrder()
                    }}
                  />
                </Box>

              </Box>
            </>
          }
        />
      </Box>
    );
  }
}

export default OrderDisplay;
